"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _customisationModule = _interopRequireDefault(require("./customisation.module.scss"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var AddBox = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref,
    className: _customisationModule["default"].addBox,
    "data-testid": "empty-customisation-card",
    onClick: function onClick() {
      return props.onNew();
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _customisationModule["default"].addTitle
  }, "Add customisation"), /*#__PURE__*/_react["default"].createElement("div", {
    className: _customisationModule["default"].addImage
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _customisationModule["default"].count
  }, props.count), /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53 53",
    width: 70,
    height: 70,
    version: "1.1"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "g850"
  }, /*#__PURE__*/_react["default"].createElement("ellipse", {
    ry: "23.670759",
    rx: "23.529016",
    cy: "27.077749",
    cx: "26.836308",
    id: "path826",
    style: {
      fill: "#3893d0",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1,
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    y: "12.289432",
    x: "22.584076",
    height: "29.009674",
    width: "8.7879467",
    id: "rect828",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1,
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    transform: "rotate(90)",
    y: "-41.293903",
    x: "22.589283",
    height: "29.009674",
    width: "8.7879467",
    id: "rect828-6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1,
      paintOrder: "stroke markers fill"
    }
  })), /*#__PURE__*/_react["default"].createElement("ellipse", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#3893d0",
      strokeWidth: 3,
      paintOrder: "stroke markers fill"
    },
    id: "path845",
    cx: "10",
    cy: "10",
    rx: "8.5390978",
    ry: "8.6651278"
  })))));
});
var _default = exports["default"] = AddBox;